import { OPERATORS, type Operand, type OperandGroups } from "./types";
import "./style.css";

export interface ReferencePanelProps {
  operands: OperandGroups;
  onInsert: (token: string) => void;
}

const Chip = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <button type="button" className="chip" onClick={onClick}>
    {label}
  </button>
);

const Group = ({
  title,
  items,
  onInsert,
}: {
  title: string;
  items: Operand[];
  onInsert: (token: string) => void;
}) =>
  items.length === 0 ? null : (
    <>
      <h3>{title}</h3>
      {items.map((o) => (
        <span key={o.slug} title={o.name}>
          <Chip label={o.slug} onClick={() => onInsert(o.slug)} />
        </span>
      ))}
    </>
  );

export const ReferencePanel = ({
  operands,
  onInsert,
}: ReferencePanelProps): JSX.Element => (
  <div className="reference-panel">
    <h3>Operators</h3>
    {OPERATORS.map((op) => (
      <Chip
        key={op.insert}
        label={op.label}
        onClick={() => onInsert(op.insert)}
      />
    ))}
    <Group title="Questions" items={operands.questions} onInsert={onInsert} />
    <Group title="Lookups" items={operands.lookups} onInsert={onInsert} />
    <Group
      title="Calculations"
      items={operands.calculations}
      onInsert={onInsert}
    />
  </div>
);

export default ReferencePanel;
